import PocketBase from "pocketbase";

// Conecta ao seu servidor Digital Ocean
// Dica: Se precisar mudar para localhost, crie um arquivo .env.local com: REACT_APP_API_URL=http://127.0.0.1:8090
const POCKETBASE_URL = process.env.REACT_APP_API_URL || "https://api.colecaoplayer.com.br";

export const pb = new PocketBase(POCKETBASE_URL);

// Opcional: Desativa cancelamento automático de requisições pendentes
// Útil se você dispara muitas requisições paralelas (como no nosso Adapter)
pb.autoCancellation(false);

// Intercepta erros globais do PocketBase para capturar status 401 (Não Autorizado) e forçar logout
const originalSend = pb.send.bind(pb);
pb.send = async (path, options) => {
  try {
    return await originalSend(path, options);
  } catch (error) {
    if (error && error.status === 401) {
      console.warn("⚠️ Sessão expirada/inválida detectada no PocketBase (401). Limpando credenciais...");
      pb.authStore.clear();
      if (typeof window !== "undefined") {
        window.dispatchEvent(new Event("pb-unauthorized"));
      }
    }
    if (error && error.status === 404 && (path?.includes("realtime") || options?.url?.includes("realtime"))) {
      console.warn("⚠️ PocketBase Realtime (SSE) indisponível no servidor (404). Desconectando cliente realtime para estancar o loop...");
      try { pb.realtime.disconnect(); } catch (_) {}
    }
    throw error;
  }
};

console.log(`📡 PocketBase Client conectado em: ${POCKETBASE_URL}`);
